export default {
  homeUi: {
    seo: {
      title: 'AQUAMARINA TOURS | Schooner, Boat and Jeep Tours in Paraty',
      description: 'AQUAMARINA TOURS - Unique ocean experiences in Paraty, RJ. Schooner tours, private boats, jeep tours along the Costa Verde, snorkeling and diving.',
    },
    hero: {
      subtitleTail: 'waiting for you in the crystal-clear waters of Paraty.',
      showcaseBadge: 'AQUAMARINA HIGHLIGHT',
      showcaseCta: 'View tour',
      showcaseAria: 'View details of {{title}}',
      experiencesAria: 'Available experiences',
      experiences: {
        schooner: 'SCHOONER',
        boat: 'SPEEDBOAT',
        jeep: 'JEEP',
        diving: 'DIVING',
      },
      featuredAria: 'Featured tours',
      route: 'PARATY · COSTA VERDE · BRAZIL',
      scrollCue: 'SCROLL TO EXPLORE',
    },
    why: {
      safety: 'Trained crew, life jackets for every passenger and vessels regularly inspected by the Brazilian Navy.',
      guides: 'Our guides know every corner of Paraty — from hidden beaches to the stories behind each island.',
      boats: 'Comfortable schooners, modern speedboats and well-maintained 4x4 jeeps. Top-quality snorkeling and diving gear.',
      price: 'No hidden fees. The price on the site is the final price. Pay by card in up to 3 installments.',
    },
    bolivia: {
      bgAlt: 'Salar de Uyuni, Bolivia',
      slideAlt: 'Salar de Uyuni Expedition',
      included: {
        accommodation: '2 Nights Accommodation',
        meals: 'All Meals',
        transport: '4x4 Transport',
        guide: 'Expert Guide',
        sunset: 'Sunset on the Salar',
        flamingos: 'Flamingos & Lagoons',
      },
    },
    trust: {
      cadasturAlt: 'Cadastur - Brazil’s National Registry of Tourism Service Providers',
      tripadvisorAlt: '5-star rating on Tripadvisor',
      tripadvisorText: 'Certificate of Excellence',
      googleAlt: '4.9 rating on Google',
      googleText: '4.9/5 Google Reviews',
      supportName: 'Customer Service',
      supportAlt: 'Customer service via WhatsApp',
      supportText: '24/7 Support',
    },
    contact: {
      mapTitle: 'Map of Paraty',
    },
    testimonials: {
      ratingAria: '{{rating}} out of 5',
    },
    footer: {
      links: 'Links',
      privacy: 'Privacy',
      cookies: 'Cookies',
      terms: 'Terms',
      reservations: 'Bookings',
      cancellations: 'Cancellations',
    },
    cart: {
      floatingAria: 'Tour cart',
    },
    countdown: {
      aria: 'Countdown timer: {{time}}',
    },
    marquee: {
      aria: 'Our experiences',
    },
  },
};
